module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', {
    staticClass: "component-credit-record-action-buttons"
  }, [_c('div', {
    staticClass: "dropdown-buttons"
  }, [(((_vm.item.type === 'PAID' || _vm.item.type === 'PROMO') && _vm.item.status !== 'EXPIRED')) ? _c('ActionButton', {
    attrs: {
      "action": _vm.expireCredit,
      "confirm": true
    }
  }, [_vm._v("Expire")]) : _vm._e(), _c('CreditRecordUsageReveal', {
    attrs: {
      "item": _vm.item
    }
  })], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d7795e6a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/CreditRecordButtons.vue
// module id = 2714
// module chunks = 1